import { NavLink } from 'react-router'
import { FiArrowRight } from 'react-icons/fi'
import { Container, Reveal, RevealGroup, HoverText } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import { featuredProgrammes } from '@/constants/featured-programmes'

export const FeaturedProgrammes = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Creating opportunities <span className="text-ibon-dark/30">through action</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-text-muted">
              Our programmes address real challenges while equipping people with practical tools,
              knowledge, and networks to shape their futures through entrepreneurship, leadership
              development, cultural exchange, and advocacy.
            </p>
          </Reveal>
        </div>

        <RevealGroup className="mt-16 flex flex-col" step={120}>
          {featuredProgrammes.map((programme) => (
            <article
              key={programme.title}
              className="group grid items-center gap-8 border-t border-border py-12 transition-colors duration-500 hover:border-ibon-sky/40 lg:grid-cols-12 lg:gap-12"
            >
              <div className="lg:col-span-7">
                <h3 className="text-2xl font-bold leading-snug tracking-tight text-ibon-dark lg:text-3xl">
                  {programme.title}
                </h3>
                <p className="mt-4 max-w-xl text-base leading-relaxed text-text-muted">
                  {programme.description}
                </p>
                <NavLink
                  to={ROUTES.PROGRAMMES}
                  className="group/link mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-ibon-dark transition-colors hover:text-ibon-sky"
                >
                  <HoverText text="Learn More" />
                  <FiArrowRight
                    className="transition-transform duration-300 group-hover/link:translate-x-1"
                    size={14}
                  />
                </NavLink>
              </div>

              <div className="overflow-hidden lg:col-span-5">
                <img
                  src={programme.image}
                  alt={programme.title}
                  className="aspect-16/10 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
            </article>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
